module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/trendimport.test/ortho-field-config-translation.json
// module id = 1271
// module chunks = 0